export const FAQS = [
    {
        platform: 'WEB',
        title: 'Get Started',
        topics: [
            'What is Halosphere Web API?',
            'How do I start working with Halosphere Web API?',
            'Is there a fee to use the API?',
            'Where can I find examples of code interacting with the API?',
        ],
    },
    {
        platform: 'WEB',
        title: 'Manage License',
        topics: [
            'How does the authentication protocol OAuth2 work?',
            'How often are API changes made that can break my code?',
            'What happens if the Access Token expires?',
            'What are the Terms of Service for the Halo Fitness for Developers Web APIs?',
        ],
    },
    {
        platform: 'WEB',
        title: 'Manage Data',
        topics: [
            'Are there any data restrictions?',
            'What kind of data can I get through the API?',
        ],
    },
    {
        platform: 'WEB',
        title: 'Other',
        topics: [
            'Which versions of browsers do you support?',
            'My question is not listed here, what should I do?',
            'I have a technical issue and need help, whom should I contact?',
            'How do I become an Halo Fitness for Developers partner?',
            'How do I report a bug or request a new feature in the Halo Fitness for Developers Web API?',
            'Where can I get the list of available SDKs?',
            'How can I change or invalidate my app credentials?',
            'What happens to my app if I\'m using older versions of the SDK for Android or iOS? Can I upgrade the ' +
            'iOS, Android and Web versions of my app at different times?',
        ],
    },
    {
        platform: 'IOS',
        topics: [
            'How do I get the Life Fitness equipment type using Halo Fitness for Developers?',
            'I don’t have Life Fitness console but I want to develop mobile app using Halo Fitness for Developers. Is ' +
            'there a way to test it without a console?',
            'The app is not automatically launched when I connect the cable to my phone. What went wrong?',
        ],
    },
    {
        platform: 'ANDROID',
        topics: [
            'How do I get the Life Fitness equipment type using Halo Fitness for Developers?',
            'I don’t have Life Fitness console but I want to develop mobile app using Halo Fitness for Developers. Is ' +
            'there a way to test it without a console?',
        ],
    },
]



// WEBPACK FOOTER //
// ./src/store/testData/faqs.js